<template>
  <page-section
    v-if="labResults && labResults.length > 0"
    class="labresults"
    :title="pageTitle"
  >
    <template #header>
      <sanity-blocks
        v-if="subTitle"
        :blocks="subTitle"
        class="pt-2 text-center heading--sm"
      />
    </template>
    <div class="container py-y-gutter-sm">
      <coa-list
        v-if="labResults && labResults.length > 0"
        :flavors="labResults"
        class="text-sm md:text-base"
      />
    </div>
  </page-section>
</template>

<script>
import CoaList from '~/components/coa-list.vue'
import sanityQuery from '~/sanity/queries/lab-results'
import page from '~/mixins/page'

export default {
  name: 'LabResults',

  components: {
    CoaList
  },

  mixins: [page],

  async asyncData({ error, query, $sanity, $sentry }) {
    const previewId = query.preview
    try {
      const page = await $sanity.fetch(sanityQuery(previewId))
      if (!page || (process.env.nonCBDSite && page.cbd)) {
        throw new Error('Lab Results page not found')
      }
      return page
    } catch (e) {
      $sentry.captureException(e)
      return error({
        statusCode: 404,
        message: e.message
      })
    }
  },

  data: () => {
    return {
      pageTitle: null,
      subTitle: null,
      labResults: null
    }
  }
}
</script>

<style>
.labresults {
  padding-top: var(--header-height) !important;
}
</style>
